import { format } from 'date-fns';

export function getApplicationReportExpirationData(expiresAt: string | undefined): {
  validityText: string | null;
  expired: boolean | null;
} {
  if (!expiresAt) {
    return { validityText: null, expired: null };
  }

  const expiresAtDate = new Date(expiresAt);
  const now = new Date();
  const isValid = expiresAtDate > now;

  return {
    validityText: isValid ? `Valid till ${format(expiresAtDate, 'MMM, d')}` : 'Expired',
    expired: !isValid,
  };
}
